// src/components/Header.js
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/Header.css";
import { useAuth } from "../context/AuthContext";

const Header = () => {
  const { isLoggedIn, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isExploreOpen, setIsExploreOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const exploreRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleExplore = (e) => {
    e.stopPropagation(); // Prevent the click from bubbling up
    setIsExploreOpen(!isExploreOpen);
  };

  const handleCollegeFinderClick = (e) => {
    e.preventDefault();
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate("/rate-my-chances");
    }
  };

  const handleAdmissionPredictorClick = (e) => {
    e.preventDefault();
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate("/rate-my-chances");
    }
  };

  const handleCounselingClick = (e) => {
    e.preventDefault();
    window.open("https://shorturl.at/uvKtH", "_blank");
  };

  // Close explore dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close the mobile menu when clicking outside
      if (
        isMenuOpen &&
        !event.target.closest(".nav-links") &&
        !event.target.closest(".hamburger")
      ) {
        setIsMenuOpen(false);
      }

      // Close the explore dropdown when clicking outside
      if (
        isExploreOpen &&
        exploreRef.current &&
        !exploreRef.current.contains(event.target)
      ) {
        setIsExploreOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isMenuOpen, isExploreOpen]);

  // Close dropdown when route changes
  useEffect(() => {
    setIsExploreOpen(false);
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Add scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Close body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <Link to="/" className="logo-link">
            <img src="/logo.png" alt="Grad4Grad Logo" className="logo-image" />
            <span className="logo-text">Grad4Grad</span>
          </Link>
        </div>

        {/* Navigation links */}
        <nav className={`nav-links ${isMenuOpen ? "active" : ""}`}>
          <div className="nav-item dropdown" ref={exploreRef}>
            <button className="dropdown-trigger" onClick={toggleExplore}>
              Explore{" "}
              <i className={`chevron ${isExploreOpen ? "up" : "down"}`}></i>
            </button>
            <div className={`dropdown-content ${isExploreOpen ? "show" : ""}`}>
              <div className="dropdown-grid">
                <div className="dropdown-section">
                  <h4>Discover</h4>
                  <Link to="/blogs" className="dropdown-link">
                    Blogs
                  </Link>
                </div>
                <div className="dropdown-section">
                  <h4>Resources</h4>
                  <button
                    className="dropdown-link"
                    onClick={handleAdmissionPredictorClick}
                  >
                    Admission Predictor
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Link
            to="/college-finder"
            className="nav-link"
            onClick={handleCollegeFinderClick}
          >
            College Finder
          </Link>
          <Link
            to="/counseling"
            className="nav-link"
            onClick={handleCounselingClick}
          >
            Free Counseling
          </Link>
          <Link to="/about-us" className="nav-link">
            About Us
          </Link>
          <Link to="/contact-us" className="nav-link">
            Contact Us
          </Link>

          <div className="auth-buttons">
            {!isLoggedIn ? (
              <Link to="/login" className="nav-link login-button">
                Login
              </Link>
            ) : (
              <button onClick={logout} className="nav-link logout-button">
                Logout
              </button>
            )}
          </div>
        </nav>

        {/* Mobile menu toggle */}
        <div
          className={`hamburger ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>

        {/* Overlay for mobile menu */}
        {isMenuOpen && (
          <div className="overlay active" onClick={toggleMenu}></div>
        )}
      </div>
    </header>
  );
};

export default Header;
